import { getSlackWebhook } from "@/helpers/apis";
import { useQuery } from '@tanstack/react-query';

export const GET_NOTIFICATION = "GET-NOTIFICATION";

const useNotifications = (isDisabled = false) => {
  const result = useQuery({
    queryKey: [GET_NOTIFICATION],
    queryFn: getSlackWebhook,
    enabled: !isDisabled,
  });
  return result;
};

export default useNotifications;
